import { brand, footer } from '../../content';
import { Logo, SmartLink } from '../../ui';

// Variant B footer: a quiet sitemap on indigo-deep. The page's final CTA band sits directly above it,
// so there is deliberately no second call to action here.
export function Footer() {
  return (
    <footer className="on-dark" style={{ background: 'var(--bm-indigo-deep)' }}>
      <div className="wrap pb-10 pt-14 md:pt-16">
        <div className="grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-[1.3fr_repeat(4,1fr)] md:gap-8">
          <div className="col-span-2 md:col-span-1">
            <Logo reversed size={32} />
            <p className="mt-5 max-w-[260px] text-[14.5px] leading-[1.55] text-white/65">{brand.line}.</p>
            <p className="mt-3 text-[14.5px] font-semibold text-white">{brand.signoff}</p>
          </div>
          {footer.columns.map((c) => (
            <nav key={c.t} aria-label={c.t}>
              <div className="font-mono text-[11px] uppercase tracking-[0.12em] text-white/45">{c.t}</div>
              <ul className="mt-4 space-y-2.5 text-[14px] text-white/75">
                {c.links.map((l) => (
                  <li key={l.h}>
                    <SmartLink href={l.h} className="hover:text-white">
                      {l.l}
                    </SmartLink>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <p className="mt-14 border-t border-white/10 pt-6 text-[12.5px] leading-[1.6] text-white/45">{footer.legal}</p>
      </div>
    </footer>
  );
}
